// AI Generated Component
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AuditlogRoutingModule } from './auditlog-routing.module';
import { AdminAuditlogComponent } from './admin-auditlog.component';
import { AdminAuditlogChangesComponent } from './changes/admin-auditlog-changes.component';
import { AdminAuditlogMoreInfoComponent } from './more/admin-auditlog-more-info.component';

// Import shared components and modules
import { SharedModule } from '@client/ng2/shared/shared.module';
import { LayoutModule, TableModule } from '@monsido/angular-shared-components';
import { ComponentsModule } from '@client/app/components/components.module';
import { UpgradePipeModule } from '@client/app/filters/upgrade-pipe.module';
import { TranslateModule } from '@client/app/modules/translate.module';
import { ModalsDirectivesModule } from '@client/app/modules/modals/directives/modals-directives.module';
import {
    MonDatePickerModule,
} from '@monsido/angular-shared-components';
import { NgCsvDirective } from '@client/app/directives/ng-csv.directive';
import { DatePickerComponent } from '@client/app/components/date-picker/date-picker.component';

@NgModule({
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    declarations: [
        AdminAuditlogComponent,
        AdminAuditlogChangesComponent,
        AdminAuditlogMoreInfoComponent,
    ],
    imports: [
        MonDatePickerModule,
        FormsModule,
        TranslateModule,
        ComponentsModule,
        UpgradePipeModule,
        CommonModule,
        AuditlogRoutingModule,
        SharedModule,
        TableModule,
        NgbModule,
        LayoutModule,
        ModalsDirectivesModule,
        NgCsvDirective,
        DatePickerComponent,
    ],
    providers: [],
})
export class AuditlogModule {}
